import { ShowHide } from "./utils";

enum BtnType {
  TEXT = "text",
  REMOVE = "remove",
}

const showHide = {
  wrap: null as HTMLElement | null,
  btn: null as HTMLElement | null,
  images: null as NodeListOf<HTMLElement> | null,
  initialized: false,

  init() {
    this.setElements();
    this.setButton();

    if (this.initialized) return;

    this.initialized = true;

    this.addBtnListener();
    this.reset();
  },

  setElements() {
    this.wrap = document.getElementById("imageWrap");
    this.btn = document.getElementById("showHideImages");

    this.images = this.wrap
      ? this.wrap.querySelectorAll<HTMLElement>(".jsSingleImage")
      : null;
  },

  setButton() {
    if (!this.btn || !this.wrap || !this.images) return;

    const limit = Number(this.btn.dataset.num ?? "4");
    const shown = Number.isFinite(limit) && limit >= 0 ? limit : 4;

    const remaining = Math.max(this.images.length - shown, 0);

    this.btn.classList.toggle("d-none", remaining === 0);

    const counter = this.btn.querySelector<HTMLElement>("#imageConter");

    if (counter) {
      counter.textContent = remaining > 0 ? `(+${remaining})` : "";
    }

    if (remaining === 0) {
      this.btn.classList.remove("activeClass");
      this.wrap.classList.remove("activeClass");
    }
  },

  addBtnListener() {
    document.addEventListener("click", (event: MouseEvent) => {
      const target = event.target;

      if (!(target instanceof Element)) return;

      if (!target.closest("#showHideImages")) return;

      this.setElements();
      this.setClasses();
    });
  },

  setClasses() {
    if (!this.btn || !this.wrap) return;

    if (this.btn.classList.contains("d-none")) return;

    const isActive = this.wrap.classList.toggle("activeClass");

    this.btn.classList.toggle("activeClass", isActive);

    const btnType = this.btn.dataset.type;

    if (btnType === BtnType.TEXT) {
      const textEl = this.btn.querySelector<HTMLElement>("span");

      if (textEl) {
        textEl.textContent = isActive ? ShowHide.SHOW_LESS : ShowHide.SHOW_MORE;
      }
    } else {
      this.btn.classList.add("d-none");
    }
  },

  reset() {
    window.addEventListener("reset", () => {
      this.setElements();

      this.wrap?.classList.remove("activeClass");
      this.btn?.classList.remove("activeClass");

      const textEl = this.btn?.querySelector<HTMLElement>("span");

      if (textEl && this.btn?.dataset.type === BtnType.TEXT) {
        textEl.textContent = ShowHide.SHOW_MORE;
      }

      this.setButton();
    });
  },
};

export default showHide;
